<template>
  <!-- 问候语 -->
  <div class="logo_desc">
    {{ greeting_msg }}
    <InfoTooltip v-if="cur_info_tool_tip_msg != null && cur_info_tool_tip_msg != ''" :text="cur_info_tool_tip_msg" />
  </div>
</template>

<script>
/* eslint-disable */
// 引入信息提示框子组件（如果是全局注册可省略）
import InfoTooltip from "./InfoTooltip.vue";
import { marked } from "marked";
import hljs from "highlight.js";
export default {
  name: "GreetingLabel", // 组件名，遵循 PascalCase 规范
  components: {
    InfoTooltip, // 注册局部组件
  },
  props: {
    greetingMsg: {
      type: String,
      // default: '欢迎使用系统！'
    },
    curInfoToolTipMsg: {
      type: String,
      // default: '这是系统自动生成的问候语'
    },
  },
  data() {
    return {
      greeting_msg: this.greetingMsg,
      cur_info_tool_tip_msg: this.curInfoToolTipMsg,
    };
  },
  mounted() {
    let rendererMD = new marked.Renderer();
    marked.setOptions({
      renderer: rendererMD,
      highlight: function (code, lang) {
        // // 优化1：超长代码块跳过高亮
        // if (code.length > 2000) return code;
        // 优化2：只对已知语言高亮
        if (lang && hljs.getLanguage(lang)) {
          return hljs.highlight(code, { language: lang }).value;
        }
        // 未指定语言的代码块，直接返回原始代码（不执行自动检测）
        return code;
        // return hljs.highlightAuto(code).value;
      },
      gfm: true, //默认为true。 允许 Git Hub标准的markdown.
      tables: true, //默认为true。 允许支持表格语法。该选项要求 gfm 为true。
      breaks: true, //默认为false。 允许回车换行。该选项要求 gfm 为true。
      pedantic: false, //默认为false。 尽可能地兼容 markdown.pl的晦涩部分。不纠正原始模型任何的不良行为和错误。
      sanitize: false, //关闭安全过滤，减少计算（开启可能导致卡顿）
      smartLists: true,
      smartypants: true, //使用更为时髦的标点，比如在引用语法中加入破折号。
      langPrefix: "hljs language-",
    });
    // this.render_greeting_msg(this.greeting_msg, this.cur_info_tool_tip_msg)
  },
  methods: {
    // 渲染greeting_msg
    render_greeting_msg(greeting_msg, tip_msg) {
      if (tip_msg != null && tip_msg != "") this.cur_info_tool_tip_msg = marked.parse(tip_msg);
      // if(tip_msg!=null && tip_msg!='') this.cur_info_tool_tip_msg = tip_msg
      else this.cur_info_tool_tip_msg = null;

      // 不传msg展示默认打招呼的信息
      let gt_msg = null;
      if (greeting_msg == null || greeting_msg == "") gt_msg = this.getGreeting();
      else gt_msg = greeting_msg;

      let line_out = this.createProgressiveText(gt_msg);
      let this_ = this;
      for (let i = 0; i < gt_msg.length; i++)
        setTimeout(() => {
          this_.greeting_msg = line_out();
        }, 20 * i);
    },
    // 线性返回文本
    createProgressiveText(text) {
      let index = 0;

      // 返回一个函数，每次调用返回累加后的文本
      return function () {
        if (index < text.length) {
          index++;
          return text.substring(0, index);
        }
        // 当所有字符都返回后，始终返回完整文本
        return text;
      };
    },
    // 获取问候语
    getGreeting() {
      // 获取当前时间
      const now = new Date();
      // 获取当前小时数（0-23）
      const hour = now.getHours();
      let greeting;
      // 判断时段
      if (hour >= 5 && hour < 12) {
        greeting = "早上好，有什么我能帮您的吗？";
      } else if (hour >= 12 && hour < 14) {
        greeting = "中午好，有什么我能帮您的吗？";
      } else if (hour >= 14 && hour < 18) {
        greeting = "下午好，有什么我能帮您的吗？";
      } else {
        greeting = "晚上好，有什么我能帮您的吗？";
      }
      return greeting;
    },
    //   /**
    //    * 手动隐藏问候语
    //    * 可被父组件调用
    //    */
    //   hideGreeting() {
    //     this.greeting_label_show_state = false;
    //   },
    //   /**
    //    * 手动显示问候语
    //    * 可被父组件调用
    //    */
    //   showGreeting() {
    //     this.greeting_label_show_state = true;
    //   },
    //   /**
    //    * 切换提示框显示状态
    //    */
    //   toggleTooltip() {
    //     this.info_tool_tip_show_state = !this.info_tool_tip_show_state;
    //   }
  },
  // beforeDestroy() {
  //   // 生命周期：组件销毁前的清理逻辑
  //   console.log('问候语组件即将销毁');
  // }
};
</script>

<style scoped>
/* 父容器样式 */
.greeting-container {
  width: 100%;
  text-align: center; /* 问候语居中 */
}
.logo_desc {
  margin: 30px auto;
  font-family: PingFang SC, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif;
  font-size: 32px;
  text-align: center;
  color: #358cef;

  font-size: 32px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: 0;
  text-align: center;
  background: linear-gradient(90deg, #358cef, #3c49dd 50%, #358cef);
  -webkit-background-clip: text;
  -webkit-text-fill-color: rgba(0, 0, 0, 0);
  background-clip: text;
}

/* 问候语文本样式 */
.greeting-text {
  margin: 30px auto;
  font-size: 32px;
  font-weight: bold;
  display: inline-flex; /* 让文本和提示框同行显示 */
  align-items: center; /* 垂直居中对齐 */
  gap: 8px; /* 文本和提示框的间距 */
}

/* 提示框图标样式 */
.tooltip-icon {
  cursor: pointer; /* 鼠标悬浮显示手型 */
  font-size: 24px; /* 提示框图标大小 */
  color: #409eff; /* 主题色，可根据项目调整 */
}
</style>
